var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.showText)?_c('div',{staticClass:"progressAmount"},[_vm._v(" "+_vm._s(_vm.percentageValue)+"% erreicht ")]):_vm._e(),_c('b-progress',{attrs:{"value":_vm.value,"max":_vm.max,"min":_vm.min,"variant":"success","height":_vm.height + 'px'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }